import React, { useState } from "react";
import InputDate from "../../components/Admin/InputDate";
import Calendario from "../../components/shared/Calendar";

const Calendar = () => {
  const [startDate, setStartDate] = useState(new Date());
  return (
    <div>
      <InputDate value={startDate} onChange={(date) => setStartDate(date)} />
    </div>
  );
};

export default Calendar;
